import { api } from 'api/v1/api';
import { removeAuthToken, removeRole } from 'api/tokenStorage';
import { useUserStore } from 'modules/Profile/model/user.store';

const publicRequestConfig: any = {
  skipAuthRefresh: true,
  skipGlobalErrorHandler: true,
  skipAuthHeader: true,
};

/** Локальные куки/стор и серверная сессия API (без Bearer). */
export async function clearAuthSession(signal?: AbortSignal): Promise<void> {
  if (signal?.aborted) return;
  removeAuthToken();
  removeRole();
  useUserStore.getState().removeUser();
  try {
    localStorage.removeItem('user');
    localStorage.removeItem('profile');
  } catch {
    // ignore
  }

  try {
    await api.post('/auth/clear-session/', null, { ...publicRequestConfig, signal });
  } catch {
    // Сессия могла уже отсутствовать - регистрация все равно должна пройти.
  }
}
